export const MASTER_UNIT_ITEM = 'MASTER_UNIT_ITEM';
export const MASTER_UNIT_ITEM_SUCCESS = 'MASTER_UNIT_ITEM_SUCCESS';
export const MASTER_UNIT_ITEM_FAILURE = 'MASTER_UNIT_ITEM_FAILURE';

export const MASTER_UNIT_WEIGHT = 'MASTER_UNIT_WEIGHT';
export const MASTER_UNIT_WEIGHT_SUCCESS = 'MASTER_UNIT_WEIGHT_SUCCESS';
export const MASTER_UNIT_WEIGHT_FAILURE = 'MASTER_UNIT_WEIGHT_FAILURE';
